import { Ray, Vector3 } from "three"
import { areVectorsEqualWithinTolerance } from "../../utils/geometryUtils";

// A continuous line, which runs through given point in a given direcion
export default class Line3d {
    #rays: Ray[];
    
    constructor(origin: Vector3, direction: Vector3)
    {
        const originPt = origin.clone();
        this.#rays = [   new Ray( originPt, direction.clone().normalize()), 
                        new Ray( originPt, direction.clone().normalize().negate())]
    }

    isParallel(input: Vector3, tolerance: number) {

        const angle = input.angleTo(this.#rays[0].direction);
        return  Math.abs(angle) < tolerance || 
                Math.abs(angle - Math.PI) < tolerance;
    }

    getDirection(target: Vector3) {
        return target.copy(this.#rays[0].direction);
    }

    setOrigin(origin: Vector3) {
        this.#rays[0].origin.copy(origin);
        this.#rays[1].origin.copy(origin);
    }

    getOrigin(target: Vector3) {
        return target.copy(this.#rays[0].origin);
    }

    clone() {
        return new Line3d(  this.#rays[0].origin.clone(), 
                            this.#rays[0].direction.clone());
    }

    equal(other: Line3d, tolerance: number) {
        if (!other) {
            return false;
        }

        // TODO: direction should not matter

        return  areVectorsEqualWithinTolerance(this.#rays[0].origin, this.getOrigin(new Vector3), tolerance) &&
                areVectorsEqualWithinTolerance(this.#rays[0].direction, this.getOrigin(new Vector3), tolerance);
    }

    isOn(point : Vector3, distanceTolerance: number) {
        return this.getPointOnLine(point, distanceTolerance) !== null;
    }

    getPointOnLine(point: Vector3, distanceTolerance: number) {
        
        for (const ray of this.#rays)
        {
            const closestPt = ray.closestPointToPoint(point, new Vector3());
            if (closestPt.distanceTo(point) < distanceTolerance)
                return closestPt;
        }
        
        return null;
    }
    
}